import 'bootstrap/dist/css/bootstrap.css';
import 'angucomplete-alt/angucomplete-alt.css';
import '../site.css';
import bootstrap from 'bootstrap-loader';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import Common from './common/common';
import Components from './components/components';
import AppComponent from './app.component';
import 'normalize.css';
import anguCompleteAlt from 'angucomplete-alt';
import blockUI from 'angular-block-ui'
import 'angular-block-ui/dist/angular-block-ui.min.css';
import './app.modal.less';
import './app.less';
import './form.less';
import 'signalr';
import uiNotification from 'angular-ui-notification';
import 'angular-ui-notification/dist/angular-ui-notification.min.css';
import uiSwitch from 'angular-ui-switch';
import 'angular-ui-switch/angular-ui-switch.css';
import { initJqElems } from './app.misc.js';
import angularGrowl from 'angular-growl-v2';
import 'angular-growl-v2/build/angular-growl.css';
import angularConfirm from 'angular-confirm1';
import 'angular-confirm1/dist/angular-confirm.min.css';
import angularJsSlider from 'angularjs-slider';
import 'angularjs-slider/dist/rzslider.css';
import angularAuth0 from 'angular-auth0';
import ngSortable from 'angular-legacy-sortablejs-maintained';
import ngMultiSelect from 'angularjs-dropdown-multiselect';
import Highcharts from "highcharts/highcharts";
import { applyTheme } from './app.theme';
import hcMarked from 'angular-marked';

//Import Tempaltes  
import enquiryNotificationTemplate from './common/templates/notification/enquiryNotificationTemplate';
import existingEnquiryTemplate from './common/templates/notification/existingEnquiryTemplate';
import sendMessageTemplate from './common/templates/notification/sendMessageTemplate';
import webEnquiriesCreatedTemplate from './common/templates/notification/webEnquiriesCreatedTemplate';
import enquiryFromWebEnquiryTemplate from './common/templates/notification/enquiryFromWebEnquiryTemplate';
import assignWebEnquiryTemplate from './common/templates/webEnquiry/assignWebEnquiry.html';
import codeweaversDataTemplate from './common/templates/webEnquiry/codeweaversDataTemplate.html';
import autoPromiseTemplate from './common/templates/promise/autoPromiseTemplate.html';
import nukeContactConfirmTemplate from './common/templates/dashboard/nukeContactConfirmTemplate.html';
import enquiryQuoteViewedTemplate from './common/templates/notification/enquiryQuoteViewedTemplate';
import editMonthlyDistributionTemplate from './common/templates/performance/editMonthlyDistributionTemplate.html';
import editUserTargetsTemplate from './common/templates/performance/editUserTargetsTemplate.html';
import marketingConsentExportTemplate from './common/templates/reports/marketingConsentExportTemplate.html';
import vehicleBrandingTemplate from './common/templates/vehicle/vehicleBrandingTemplate.html';
import editEnquirySourceTemplate from './common/templates/admin/editEnquirySourceTemplate.html';
import financeCreatedTemplate from './common/templates/notification/financeCreatedTemplate';
import docuSignAuthConsentTemplate from './common/templates/enquiry/docuSignAuthConsentTemplate.html';
import signatureEventTemplate from './common/templates/notification/signatureEventTemplate';
import mazdaAuthConsentTemplate from './common/templates/vehicle/mazdaAuthConsentTemplate.html';
import addCustomFormTemplate from './common/templates/customForms/addCustomFormTemplate.html';
import mercUsedWarranty from './common/templates/customForms/mercUsedWarranty.html';
import stockProviderTemplate from './common/templates/admin/stockProviderTemplate.html';
import webLeadFollowUpEmailTemplate from './common/templates/enquiry/webLeadFollowUpEmailTemplate.html';
import scheduledReportEditTemplate from './common/templates/reports/scheduledReportEditTemplate.html';
import contactViewEnquiryRegs from './common/templates/contact/contactViewEnquiryRegs.html';
import telecomProviderTemplate from './common/templates/admin/telecomProviderTemplate.html';
import exportContactsTemplate from './common/templates/contact/exportContactsTemplate.html';
import callLogViewTemplate from './common/templates/contact/callLogViewTemplate.html';
import editProductTemplate from './common/templates/product/editProduct.html';
import editContactTemplate from './common/templates/contact/editContactTemplate.html';
import editInvoicePaymentTemplate from './common/templates/accounting/editInvoicePaymentTemplate.html';

let appModule = angular.module('app', [
    uiRouter,
    Common,
    Components,
    'angucomplete-alt',
    'blockUI',
    'ui-notification',
    'uiSwitch',
    'angular-growl',
    'cp.ngConfirm',
    'rzModule',
    'auth0.auth0',
    'ng-sortable',
    'angularjs-dropdown-multiselect',
    'hc.marked',
  ])
  .config(($locationProvider) => {
    "ngInject";
    // @see: https://github.com/angular-ui/ui-router/wiki/Frequently-Asked-Questions
    // #how-to-configure-your-server-to-work-with-html5mode
    $locationProvider.html5Mode(true).hashPrefix('!');

    //Global Settings
    String.prototype.toCamelCase = function() {
        return this.replace(/^([A-Z])|\s(\w)/g, function(match, p1, p2, offset) {
            if (p2) return p2.toUpperCase();
            return p1.toLowerCase();
        });
    };

    String.prototype.replaceAll = function(search, replacement) {
      var target = this;
      return target.replace(new RegExp(search, 'g'), replacement);
  };

    Date.prototype.withoutTime = function () {
        var d = new Date(this);
        d.setHours(0, 0, 0, 0);
        return d;
    };

    Date.prototype.getUTCTime = function(){
      return new Date(
        this.getUTCFullYear(),
        this.getUTCMonth(),
        this.getUTCDate(),
        this.getUTCHours(),
        this.getUTCMinutes(),
        this.getUTCSeconds()
      ).getTime();
    };

    Date.prototype.toUniversalFormat = function(){
      return this.getFullYear() + '-' + (this.getMonth() + 1) + '-' + this.getDate();
    };

    // Radialize the colors
    Highcharts.setOptions({
      colors: Highcharts.map(Highcharts.getOptions().colors, function (color) {
          return {
              radialGradient: {
                  cx: 0.5,
                  cy: 0.3,
                  r: 0.7
              },
              stops: [
                  [0, color],
                  [1, Highcharts.color(color).brighten(-0.3).get('rgb')] // darken
              ]
          };
      })
    });      
  })

  .config((angularAuth0Provider, appConfig) => {
    "ngInject";

    angularAuth0Provider.init({
      clientID: appConfig.auth0.clientId,
      domain: appConfig.auth0.domain,
      responseType: 'token id_token',
      scope: 'openid email profile'
    });    
  })

  .config((blockUIConfig) => {
    "ngInject";
    blockUIConfig.autoBlock = false;
    blockUIConfig.delay = 10;
  })

  .run(($templateCache) => {
    "ngInject";

    $templateCache.put('templates/notification/enquiryNotificationTemplate', enquiryNotificationTemplate);
    $templateCache.put('templates/notification/existingEnquiryTemplate', existingEnquiryTemplate);
    $templateCache.put('templates/notification/sendMessageTemplate', sendMessageTemplate);
    $templateCache.put('templates/notification/enquiryFromWebEnquiryTemplate', enquiryFromWebEnquiryTemplate);
    $templateCache.put('templates/notification/webEnquiriesCreatedTemplate', webEnquiriesCreatedTemplate);
    $templateCache.put('templates/webEnquiry/assignWebEnquiry', assignWebEnquiryTemplate);        
    $templateCache.put('templates/webEnquiry/codeweaversDataTemplate', codeweaversDataTemplate);        
    $templateCache.put('templates/promise/autoPromiseTemplate', autoPromiseTemplate);   
    $templateCache.put('templates/dashboard/nukeContactConfirmTemplate', nukeContactConfirmTemplate);                
    $templateCache.put('templates/notification/enquiryQuoteViewedTemplate', enquiryQuoteViewedTemplate);    
    $templateCache.put('templates/performance/editMonthlyDistributionTemplate', editMonthlyDistributionTemplate);                    
    $templateCache.put('templates/performance/editUserTargetsTemplate', editUserTargetsTemplate);                    
    $templateCache.put('templates/reports/marketingConsentExportTemplate', marketingConsentExportTemplate);                    
    $templateCache.put('templates/vehicle/vehicleBrandingTemplate', vehicleBrandingTemplate);                        
    $templateCache.put('templates/admin/editEnquirySourceTemplate', editEnquirySourceTemplate);     
    $templateCache.put('templates/notification/financeCreatedTemplate', financeCreatedTemplate);
    $templateCache.put('templates/enquiry/docuSignAuthConsentTemplate', docuSignAuthConsentTemplate);
    $templateCache.put('templates/notification/signatureEventTemplate', signatureEventTemplate);    
    $templateCache.put('templates/vehicle/mazdaAuthConsentTemplate', mazdaAuthConsentTemplate);
    $templateCache.put('templates/customForms/addCustomFormTemplate', addCustomFormTemplate);    
    $templateCache.put('templates/customForms/mercUsedWarranty', mercUsedWarranty);    
    $templateCache.put('templates/admin/stockProviderTemplate', stockProviderTemplate);    
    $templateCache.put('templates/enquiry/webLeadFollowUpEmailTemplate', webLeadFollowUpEmailTemplate);        
    $templateCache.put('templates/reports/scheduledReportEditTemplate', scheduledReportEditTemplate);        
    $templateCache.put('templates/contact/contactViewEnquiryRegs', contactViewEnquiryRegs);
    $templateCache.put('templates/admin/telecomProviderTemplate', telecomProviderTemplate);    
    $templateCache.put('templates/contact/exportContactsTemplate', exportContactsTemplate);    
    $templateCache.put('templates/contact/callLogViewTemplate', callLogViewTemplate);        
    $templateCache.put('templates/product/editProductTemplate', editProductTemplate);            
    $templateCache.put('templates/contact/editContactTemplate', editContactTemplate);    
    $templateCache.put('templates/accounting/editInvoicePaymentTemplate', editInvoicePaymentTemplate);        
      })

  .run((appConfig, $location) => {
    "ngInject";

    //Determine the URL being used (localhost / carsnowdev / leadmanager / carsnow-prod)
    appConfig.oauthCallbackUrl = $location.protocol() + '://' 
      + $location.host() 
      + (($location.port() === 80 || $location.port() === 443) ? '' : `:${$location.port()}`) 
      + '/login';
    
    //Set the baseApiUrl 
    appConfig.apiServiceBaseUri = $location.protocol() + '://'
      + $location.host() 
      + (($location.port() === 80 || $location.port() === 443) ? '' : `:30641/`) 
      + (($location.port() === 80 || $location.port() === 443) ? '/api/' : '');

    if (appConfig.oauthCallbackUrl.search('localhost') !== -1) {
      appConfig.appTitle = "Cars Now Localhost";
    }
    else if (appConfig.oauthCallbackUrl.search('carsnowdev.com') !== -1) {
      appConfig.appTitle = "Cars Now Dev";
    }    
    else if (appConfig.oauthCallbackUrl.search('carsnow.ie') !== -1) {
      appConfig.appTitle = "Cars Now";
    }        
    else if (appConfig.oauthCallbackUrl.search('leadmanagerdev.com') !== -1) {
      appConfig.appTitle = "Lead Manager Dev";
    }        
    else if (appConfig.oauthCallbackUrl.search('leadmanager.ie') !== -1) {
      appConfig.appTitle = "Lead Manager";
    }          
    
    appConfig.isLeadManager = appConfig.appTitle.toLowerCase().search('lead manager') !== -1;
    //appConfig.isLeadManager = true;
    //Theme Configurator
    appConfig.switchTheme = () => {
      //Set Base Image Path
      if (!appConfig.isLeadManager) {
        appConfig.imagePath = "images";
        appConfig.supportEmail = "support@carsnow.ie";
      }
      else{
        appConfig.imagePath = "images/leadmanager";
        appConfig.supportEmail = "support@leadmanager.ie";
      }

      //Update favicon
      document.getElementById("favicon").setAttribute("href", `${appConfig.imagePath}/menu-btn.png`);

      //Apply Theme Color
      applyTheme(appConfig.isLeadManager)
    };
    appConfig.switchTheme();
        
    console.log('oauthCallbackUrl', appConfig.oauthCallbackUrl);
    console.log('apiServiceBaseUri', appConfig.apiServiceBaseUri);    
  })
  
  .run(($transitions, pushService, appConfig) => {
    "ngInject";

    $transitions.onSuccess({}, function(transition) {
      const isMobileDevice = window.navigator.userAgent.toLowerCase().includes("mobi");     
      document.body.style.position = '';

      if (isMobileDevice && (transition.to().name === 'simpleDpa' || transition.to().name === 'allDpa')) {
        document.body.style.position = 'fixed';
      }

      document.title = appConfig.appTitle;
      initJqElems();
      pushService.init();
    });
  })

  .constant('enums', {
    PERMISSION_TYPE: {
      View: 1,
      Add: 2,
      Edit: 4,
      Delete: 8
    },

    ENTITY_TYPE: {
      Company: 1,
      Dealer: 2,
      Location: 3
    },

    OBJECT_ROW_STATE: {
      Active: 1,
      Inactive: 2,
      Deleted: 3
    },

    MEDIA_TYPE: {
      Image: 1,
      Video: 2,
      ExternalImage: 3,
      Youtube: 4
    },

    VEHICLE_STATUS: {
      DueIn: 1,
      InStock: 2,
      Sold: 3,
      Delivered: 4,
      Discontinued: 5,
      Pending: 6
    },

    VEHICLE_CONDITION: {
      New: 1,
      Used: 2
    },

    AUTO_SOLD: {
      Retail: 1,
      Trade: 2
    },

    VEHICLE_CONDITION_SEARCH: {
      All: 0,
      New: 1,
      UsedRetail: 2,
      UsedTrade: 3
    },

    COMPANY_TYPE: {
      Limited: 1,
      Partnership: 2,
      SoleTrader: 3
    },

    CONTACT_TYPE: {
      Customer: 1,
      Supplier: 2,
      Trader: 3,
      RetailFleet: 4,
      Other: 5
    },

    PERSON_TITLE: {
      Dr: 1,
      Mr: 2,
      Miss: 3,
      Ms: 7,
      Mrs: 4,
      Rev: 5,
      Other: 6,
      Sr: 8
    },

    CONTACT_METHOD: {
      Phone: 1,
      Email: 2,
      Post: 3
    },

    ENQUIRY_PRICE_TYPE: {
      Cost: 1,
      Discount: 2
    },

    ENQUIRY_PAYMENT_MODE: {
      Cash: 1,
      EFT: 3,
      Cheque: 5,
      Finance: 6
    },

    ENQUIRY_ORIGINATION: {
        WalkIn: 1,
        Phone: 2,
        Email: 3,
        Web: 4,
        CarsNowApp: 11,
        InboundCall: 12,
        OutboundCall: 13,
    },

    ENQUIRY_CONTACT: {
        Trade: 1,
        Retail: 2,
    },

    ENQUIRY_STATE: {
      Open: 1,
      Lost: 2,
      Confirmed: 3,
      Closed: 4
    },

    ENQUIRY_LOST_REASON: {
        Price: 1,
        Availability: 2,
        Recommendation: 3,
        "Quality Of Service": 4,
        "Finance Rates": 5,
        "Opened In Error": 6,
        "Finance Declined": 7,
        "Bought Non Franchise": 8,
        "Bought From Competitor": 9,
        "Not Changing Until": 10,
        "Bought From Different Enquiry": 11,
        "No Further Contact Possible": 12,
        "Closed by Admin": 13
    },

    FUEL_TYPE: {
      Petrol: 1,
      Diesel: 2,
      Hybrid: 3,
      BiFuel: 4,
      Electric: 5,
      LPG: 6,
      BioGas: 7,
      Other: 8,
      BioFuel: 9,
      DieselHybrid: 10,
      DieselPlugInHybrid: 11,
      DualFuel: 12,
      PetrolEthanol: 13,
      PetrolHybrid: 14,
      PetrolPlugInHybrid: 15,
      UnspecifiedHybrid: 16,      
    },

    VEHICLE_BODY_TYPE: {
      Cabriolet: 1,
      Coupe: 2,
      Estate: 3,
      Hatchback: 4,
      MPV: 5,
      Saloon: 6,
      SUV: 7,
      LCV: 8,
      "4x4": 9,
      "Mini MPV": 10,
      Van: 11,
      Bus: 12,
      "Panel Van": 13,
      PickUp: 14,
      Commercial: 15,
      "Mini Bus": 16,
      "Chassis Cab": 17,
      "Crew Cab Pickup": 18,
      "Sport Mini": 19,
      "Lift Back": 20,
      "Car Derived Van": 21,
      Roadster: 22,
      "Station Wagon": 23,
      Hatch: 24,
      Quadcycle: 25
    },

    ENQUIRY_PRICE_GROUP_TYPE: {
      VehiclePricing: 1,
      Extras: 2,
      FinancialProducts: 3,
      Misc: 4
    },

    TRANSMISSION_TYPE: {
        Manual: 1,
        Automatic: 2
    },

    VEHICLE_TYPE: {
        Car: 1,
        Commercial: 2
    },

    ENQUIRY_TYPE: {
      Sales: 1,
      Aftersales: 2
    },

    ENQUIRY_SUBTYPE: {
      New: 1,
      Used: 2,
      BuyIn: 3,
      FinanceQuote: 4,
      Unsure: 5,
      ServiceBooking: 6,
      RepairsRequired: 7,
      Parts: 8,
      TechQuery: 9
    },

    PROMISE_CATEGORY: {
      Customer: 1,
      Business: 2,
      Personal: 3
    },

    MILEAGE_TYPE: {
        Km: 1,
        Mi: 2
    },

    COLOR: {
        Beige: 1,
        Black: 2,
        Blue: 3,
        Bronze: 4,
        Brown: 5,
        Gold: 6,
        Green: 7,
        Grey: 8,
        Maroon: 9,
        Navy: 10,
        Orange: 11,
        Pink: 12,
        Purple: 13,
        Red: 14,
        Silver: 15,
        Various: 16,
        White: 17,
        Wine: 18,
        Yellow: 19
    },

    DATE_RANGE_TYPE: {
        Today: 1,
        Yesterday:  2,
        'This Week': 3,
        'This Month to date': 4,
        'This Month': 5,
        'This Quarter': 6,
        'This Year': 7,
        'This Year to date': 8,
        'Last Week': 9,
        'Last Month': 10,
        'Last Quarter': 11,
        'Next Week': 12,
        'Next Month': 13,
        'Next Quarter': 14,
        Custom: 100
    },

    USER_WORK_TYPE: {
        Sales: 1,
        Aftersales: 2
    },

    RESIDENCE_TYPE: {
        Owner: 1,
        Tenant: 2,
        LWP: 3
    },

    GENDER: {
        Male: 1,
        Female: 2
    },

    MARITAL_STATUS: {
        Single: 1,
        Married: 2,
        'Civil Partner': 3,
        Divorced: 4,
        Widowed: 5
    },

    EMPLOYMENT_TYPE: {
        FullTime: 1,
        PartTime: 2,
        SelfEmployed: 3
    },

    FINANCE_STATE: {
      Awaiting_Approval: 1,
      Finance_Accepted: 2,
      Finance_Rejected: 3,
      Customer_Accepted: 4,
      Customer_Rejected: 5
    },

    FINANCE_TYPE: {
      HP: 1,
      PCP: 2
    },

    AUTO_PROMISE_TRIGGER: {
      "New contact created": 1,
      "Enquiry created on a new vehicle": 2,
      "Enquiry confirmed on a new vehicle" : 3,
      "Enquiry closed on a new vehicle": 4,
      "Finance created on a new vehicle": 5,
      "Finance accepted by customer on a new vehicle": 6,
      "Enquiry created on a used vehicle": 7,
      "Enquiry confirmed on a used vehicle" : 8,
      "Enquiry closed on a used vehicle": 9,
      "Finance created on a used vehicle": 10,
      "Finance accepted by customer on a used vehicle": 11,
      "New Web Enquiry Received": 12,
    },

    TIMESPAN_TYPE: {
      Day: 1,
      Week: 2,
      Month: 3,
      Year: 4
    },

    APPRAISAL_QUALITY: {
      Excellent: 1,
      Good: 2,
      Fair: 3,
      Poor: 4
    },

    ENQUIRY_CONFIRMED_EMAIL_TYPE: {
        Unknown: 0,
        Retail: 1,
        Trade: 2,
        BuyIn: 4
    },

    REPORTABLE_ADDON_TYPE: {
      All: 1,
      Chargeable: 2,
      Complimentary: 3
    },    

    OMNISEARCH_OBJECT_TYPE: {
      Enquiry: 1,
      Contact: 2
    },

    COMPONENT_STATE: {
      Uninitialized: 0,
      Loading: 1,
      Completed: 2
    },

    WEB_ENQUIRY_SOURCE: {
      Email: 0,
      Lucid: 1,
      Api: 2,
    },

    WEB_PUBLISHER_TYPE: {
      EasierAd: 1,
      StockLoader: 2
    },

    SIGNATURE_STATUS: {
      Created: 1,
      Voided: 2,
      CustomerSigned: 3,
      CustomerDeclined: 4,
      Completed: 5,
      DealerDeclined: 6,
    },

    DEFAULT_LANDING_PAGE: {
      WelcomeCentre: 0,
      Dashboard: 1,
      LeadMonitor_WebEnquiries_Today: 2,
      LeadMonitor_WebEnquiries_ThisWeek: 3,
      LeadMonitor_WebEnquiries_LastWeek: 4,
      LeadMonitor_Enquiries_Today: 5,
      LeadMonitor_Enquiries_ThisWeek: 6,
      LeadMonitor_Enquiries_LastWeek: 7,
    },

    ENTITY_META_TYPE: {
      EnquiryManageGroupHash: 1,
      EnquiryManageFranchiseHash: 2,
      WebLeadFollowUpEmail: 3,
      DisplayInDashboard: 4,
      EnquiryManageLocationHash: 5,
      MarketingSourceRequired: 6,
      SalutationEnabled: 7,
      TelecomProvider: 8,    
      MandatoryMakeModel: 9,
      ConfirmedEnquiryComplianceTemplate: 10,
      InvoiceDetails: 11,  
    },

    SCHEDULED_REPORT_FREQUENCY: {
        Daily: 1,
        Weekly: 2,
        //BiWeekly: 3,
        Monthly: 4,
        Quarterly: 5
    },    

    SCHEDULED_REPORT_OUTPUT_TYPE: {
      Html: 1,
      Pdf: 2,
      Excel: 3
    },

    SCHEDULED_REPORT_OUTPUT_TYPE_TEMP: {
      Html: 1,
      Excel: 3
    }, 
    
    INVOICE_STATUS: {
      Draft: 1,
      Issued: 2,
      Paid: 3,
      Voided: 4,
      Deleted: 5  
    }, 
  })

  .filter("trustUrl", ($sce) => {
    "ngInject";

    return (recordingUrl) => {
      return $sce.trustAsResourceUrl(recordingUrl);
    };
  })

  .filter("time", () => {
    "ngInject";

    return (sec) => {
      var sec_num = parseInt(sec, 10); // don't forget the second param
      var hours   = Math.floor(sec_num / 3600);
      var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
      var seconds = sec_num - (hours * 3600) - (minutes * 60);

      if (hours   < 10) {hours   = "0"+hours;}
      if (minutes < 10) {minutes = "0"+minutes;}
      if (seconds < 10) {seconds = "0"+seconds;}
      return hours+':'+minutes+':'+seconds;
    };
  })

  .directive('ngEnumFlag', function () {
    return {
        restrict: 'A',
        scope: {
            value: '=ngEnumFlag',
            model: '=ngEnumModel'
        },
        link: function (scope, element) {
            var checkbox = element[0];
            element.on('change', function () {
                scope.$apply(function () {
                    if (checkbox.checked) {
                        scope.model += scope.value;
                    } else {
                        scope.model -= scope.value;
                    }
                });
            });
            scope.$watch('model', function () {
                checkbox.checked = (scope.model & scope.value) == scope.value;
            });
        }
    };
  })

  .directive('inputRestrictor', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            value: '=ngEnumFlag',
            model: '=ngEnumModel'
        },
        link: function (scope, element, attr, ngModelCtrl) {
          var pattern = /[^a-z0-9]/gi;
          function fromUser(text) {
              if (!text)
                  return text;

              var transformedInput = text.replace(pattern, '');
              if (transformedInput !== text) {
                  ngModelCtrl.$setViewValue(transformedInput);
                  ngModelCtrl.$render();
              }
              return transformedInput;
          }
          ngModelCtrl.$parsers.push(fromUser);
      }
    };
  })

  .component('app', AppComponent)

  .name;

export default appModule;



// WEBPACK FOOTER //
// ./client/app/app.js